import type FormValues from '~/client/components/Auth/Register/RegisterBody/FormRegister/useFormRegister/FormValues';
import useHandleSportsbetRegister from '~/client/components/Auth/Register/RegisterBody/FormRegister/useFormRegister/useHandleRegister/useHandleSportsbetRegister';
import useRequestEmailVerification from '~/client/components/Auth/Register/RegisterBody/FormRegister/useFormRegister/useHandleRegister/useRequestEmailVerification';
import setDataToGib from '~/client/components/Auth/Shared/utils/setDataToGib';
import useUpdateGtmUserData from '~/client/components/Auth/Shared/utils/useUpdateGtmUserData';
import useCid from '~/client/hooks/cookies/marketing/useCid';
import useRefAff from '~/client/hooks/cookies/marketing/useRefAff';
import useRefCode from '~/client/hooks/cookies/marketing/useRefCode';
import useFriendRef from '~/client/hooks/cookies/useFriendRef';
import useLanguage from '~/client/hooks/useLanguage';
import useSite from '~/client/hooks/useSite';
import startFraudEngine from '~/client/shared/fraud/fraudEngine';
import useToken from '~/shared/hooks/useToken';
import trackEvent from '~/shared/trackEvent';
import authType from '~/shared/utils/auth/authType';
import SessionStorage from '~/shared/utils/storage/SessionStorage';
import useHandleAuthenticate from './useHandleAuthenitcate';
import useSocialAuthLocale from '../../SocialAuth/hooks/useSocialAuthLocale';
import useUpdateUserLanguage from '../../SocialAuth/hooks/useUpdateUserLanguage';

const useHandleCompleteRegistration = () => {
  const { requestEmailVerification } = useRequestEmailVerification();
  const { site, isBridgeSite } = useSite();
  const [, setToken] = useToken();
  const { code: language } = useLanguage();
  const refCode = useRefCode();
  const [refAff] = useRefAff();
  const [friendRef] = useFriendRef();
  const [cid] = useCid();
  const accessToken = SessionStorage?.getItem('social_auth_token') as string;
  const updateUserLanguage = useUpdateUserLanguage();

  const { handleSportsbetRegister } = useHandleSportsbetRegister();
  const { updateGtmUserData } = useUpdateGtmUserData();
  const [, , clearSocialAuthLocale] = useSocialAuthLocale();
  const { handleAuthenticate, loading } = useHandleAuthenticate();

  const handleCompleteRegistration = async (
    values: Omit<FormValues, 'dateOfBirth'> & { dateOfBirth: number },
  ) => {
    const { username, email, dateOfBirth, offers, phone } = values;

    const variables = {
      username,
      email,
      dateOfBirth,
      phone,
      offers,
      site,
      language,
      domain: window.location.hostname,
      refCode,
      refAff,
      cid,
      friendRef,
    };

    const {
      token = '',
      deviceDataToken = '',
      errors,
      sessionId,
      userManagement,
    } = await handleAuthenticate(variables, accessToken);

    if (errors) {
      return { errors };
    }

    setToken(token);
    startFraudEngine({ deviceDataToken });
    await updateGtmUserData({ authToken: token });
    await updateUserLanguage(language);
    trackEvent({}, 'registrationSuccess');
    trackEvent({}, 'completeRegistrationSuccess');
    requestEmailVerification();

    if (userManagement?.currentProfile?._id && sessionId) {
      setDataToGib(userManagement?.currentProfile?._id, sessionId);
    }

    authType.remove();
    SessionStorage.removeItem('social_auth_missing_fields');
    SessionStorage.removeItem('social_auth_token');
    clearSocialAuthLocale();

    if (isBridgeSite) {
      handleSportsbetRegister();
    }

    return {};
  };
  return {
    loading,
    handleCompleteRegistration,
  };
};

export default useHandleCompleteRegistration;
